<template>
  <div class="input-wrapper">
    <label
      v-if="label"
      class="input__label"
      :for="id">{{ label }}
    </label>

    <div class="input-core-wrapper">
      <dropdown>
        <app-button theme="light-gray" class="margin" type="primary">
          Dropdown<i class="el-icon-arrow-down el-icon--right"></i>
        </app-button>
          <dropdown-menu slot="dropdown">
            <dropdown-item>Action 1</dropdown-item>
            <dropdown-item>Action 2</dropdown-item>
            <dropdown-item>Action 3</dropdown-item>
            <dropdown-item disabled>Action 4</dropdown-item>
            <dropdown-item divided>Action 5</dropdown-item>
          </dropdown-menu>
        </dropdown>

      <!-- <input-message
        v-if="hasErrors"
        :text="errors.first(id)"
        :is-extended="isExtended">
      </input-message> -->
    </div>
  </div>
</template>

<script>
import { Dropdown } from 'element-ui';
import { DropdownItem  } from 'element-ui';
import { DropdownMenu  } from 'element-ui';
import AppButton from '@/components/Buttons/PrimaryButton.vue'

import { validatorMixin } from './validator.mixin';

export default {
  name: 'dropdown',
  components: {
    Dropdown,
    DropdownItem,
    DropdownMenu,
    'app-button': AppButton
  },
  mixins: [validatorMixin],
  props: {
    props: {
      theme: {
        type: String,
        required: false,
        validator (value) {
          const allowedValues = [
            'dark-blue',
            'green',
            'light-gray',
            'cyan',
            'white-bordered'
          ];
          return validateArrayInput(allowedValues, value);
        }
      },
      height: {
        type: String,
        required: false,
        default: '38px'
      },
      minWidth: {
        type: String,
        required: false,
        default: 'auto'
      },
      fontSize: {
        type: String,
        required: false,
        default: 'small',
        validator (value) {
          const allowedValues = ['regular', 'small', 'mini'];
          return validateArrayInput(allowedValues, value);
        }
      },
      disabled: {
        type: Boolean,
        required: false,
        default: false
      },
      type: {
        type: String,
        required: false,
        default: 'button'
      },
      fontWeight: {
        type: [String, Number],
        required: false,
        default: 700
      }
    },
    label: {
      type: [String, Number],
      required: false
    },
    placeholder: {
      type: String,
      required: true
    },
    isExtended: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    dropdownClass () {
      return {
        ['dropdown_text_' + this.fontSize]: true,
        ['dropdown_theme_' + this.theme]: true
      };
    },
    dropdownStyles () {
      return {
        height: this.height,
        minWidth: this.minWidth,
        pointerEvents: this.disabled ? 'none' : 'auto',
        fontWeight: this.fontWeight
      };
    }
  }
};
</script>

<style lang="scss" scoped>
   .el-dropdown-link {
    cursor: pointer;
    color: #409EFF;
  }
  .margin {
    margin: 0 5px
  }
  .el-icon-arrow-down {
    font-size: 12px;
  }
   // font-size
   .dropdown_text_regular
     {
       font-size: 1rem
     }

   .dropdown_text_small
     {
      font-size: 0.8125rem
     }

   .dropdown_text_mini
    {
     font-size: 0.6875rem
    }   
    //themes
   .dropdown_theme_dark-blue {
     background-color: #027fa0
     color #fff

    //  &:hover
    //    background-color #029fca
   }

</style>
